module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s05-ttl_s-62f1b97a6f4e0d8c5493a995cd01d7ff.png";